export default __webpack_public_path__ + "static/media/pet-cin-ufpe.5c375d4d.svg";